<template>
  <div>
    <el-row>
      <el-col>
        <el-form :inline="true" class="demo-form-inline" style="padding:0;margin:0" size="medium">
          <el-form-item label="产品名称：">
            <el-input v-model="searchForm.name" @keyup.enter.native="handleSearch()" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch" :loading="loading">筛选</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="multyAdd" :loading="putOnLoading" :disabled="putOnRowLoadingId !== 0">批量上架</el-button>
            <el-button type="primary" plain @click="exportOrder">导出信息</el-button>
            <el-button @click="importVisible = true">导入库位信息</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" stripe border style="width: 100%" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="产品" min-width="80"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="编码" min-width="210">
            <template slot="header">
              <el-row>
                <el-col :span="5" style="margin-top:2.5px;text-align:left"><span>编码</span></el-col>
                <el-col :span="19">
                  <el-input clearable v-model="search_code" size="mini" placeholder="搜索" />
                </el-col>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位" min-width="50"></el-table-column>
          <el-table-column prop="PRODUCT_PRICE" label="单价" min-width="70"></el-table-column>
          <el-table-column prop="TEMP_ID" label="明细ID" min-width="50"></el-table-column>
          <el-table-column prop="BATCH" label="批次" min-width="70"></el-table-column>
          <el-table-column label="保质期" min-width="60">
            <template slot-scope="scope">
              <span>{{ scope.row.QGP + QGP_TIME_TYPE[scope.row.QGP_TIME_TYPE] }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="库存数量" min-width="50"></el-table-column>
          <el-table-column prop="PRODUCT_WORTH" label="剩余价值" min-width="50"></el-table-column>
          <el-table-column label="库位" min-width="200">
            <template slot="header">
              <el-col :span="5" style="margin-top:2.5px;text-align:left"><span>库位</span></el-col>
              <el-col :span="19">
                <el-select size="mini" v-model="search_position" clearable filterable :filter-method="positionFilter" @visible-change="positionReset">
                  <el-option v-for="item in positionList" :key="item.ID" :value="item.CODE" :label="item.CODE">
                  </el-option>
                </el-select>
              </el-col>
            </template>
            <template slot-scope="scope">
              <el-select v-model="scope.row.LOCATION_CODE" clearable filterable :filter-method="positionFilter" @visible-change="positionReset">
                <el-option v-for="item in positionList" :key="item.ID" :value="item.CODE" :label="item.CODE"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="addToStock(scope.row)" :loading="putOnRowLoadingId === scope.row.TEMP_ID"
                :disabled="putOnRowLoadingId !== 0 || putOnLoading">上架</el-button><br>
              <el-button v-show="scope.row.BATCH_REPORT_ID !== 0" size="small" type="text" @click="downloadBatch(scope.row.BATCH_REPORT_ID)">
                下载批次报告
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-dialog title="导入上架信息" center :visible.sync="importVisible" width="400px" :close-on-click-modal="false">
      <el-form size="small" ref="importForm" :model="importForm" style="padding-left: 30px;">
        <el-upload class="upload-demo" action="/uploadFile" :on-success="handleSuccess" :on-remove="handleRemove" :name="this.importForm.file"
          multiple :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过5M</div>
        </el-upload>
        <el-form-item>
          <span @click="downLoadResetTemp" style="color:#409EFF">点此下载导入模板</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeImport()">取 消</el-button>
        <el-button size="small" @click="submitImport('importForm')">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="查看批次报告" center :visible.sync="查看批次报告模态框" width="400px" :close-on-click-modal="false">
      <el-form size="small" ref="查看批次报告模态框表单" :model="查看批次报告模态框表单" label-width="120px">
        <el-form-item label="送检单位" prop="SUBMIT_UNIT">
          <el-input v-model="查看批次报告模态框表单.SUBMIT_UNIT" disabled style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="检测报告" prop="TEST_UNIT">
          <el-input v-model="查看批次报告模态框表单.TEST_UNIT" disabled style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="批次报告">
          <el-button type="text" @click="下载批次报告()">下载报告</el-button>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="查看批次报告模态框 = false">取 消</el-button>
        <el-button size="small" @click="查看批次报告模态框 = false">确 定</el-button>
      </div>
    </el-dialog>
    <!-- <div class="pagination_box" style="text-align: right">
            <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage"
              :page-size="pageSize" layout="total,prev, pager, next, jumper" :total="totalCount">
            </el-pagination>
        </div> -->
  </div>
</template>
<script>
import {
  queryTemporary, exportWarehouseFun, putOnStock, putOnStock_multy, temporaryExport, temporaryImport, queryPosition,
} from '@/assets/api/warehouseManager';
import { downloadBatchReport } from '@/assets/api/shopOrderManage';
import { frontEndFun } from '@/assets/api/frontFun';

export default {
  data() {
    return {
      PAGE_ID: '11208', // 页面ID 一旦规定不要轻易改动
      fun_dic: { 1120801: 0, 1120802: 0 }, // 功能ID 一旦规定不要轻易改动
      loading: false,
      exportFormVisible: false,
      exportForm: {},
      firstList: [],
      secondList: [],
      returnVisible: false,
      showStatus: 0,
      returnForm: {},
      count: 0,
      showAll: true,
      searchForm: {
        name: '',
      },
      firstTypeList: [],
      TAB_CODE: '',
      total_price: 0,
      tableData: [],
      totalCount: 0,
      // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      currentPage: 1,
      addForm: {},
      formLabelWidth: '120px',
      putOnArr: [],
      putOnLoading: false,
      putOnRowLoadingId: 0,
      positionList: [],
      positionListAll: [],
      search_code: '',
      tableData_ALL: [],
      search_position: '',
      url: '',
      fileList: [],
      importForm: {
        file: 'tmp',
      },
      importVisible: false,
      QGP_TIME_TYPE: ['', '年', '季', '个月', '天', '小时'],
      查看批次报告模态框: false,
      查看批次报告模态框表单: {},
    };
  },
  mounted() {
    this.queryBeforeFun();
    if (this.WMS_TEMPORARYSTOCK_CONDITION.CONDITION) {
      this.searchForm = this.WMS_TEMPORARYSTOCK_CONDITION.CONDITION;
      this.currentPage = this.WMS_TEMPORARYSTOCK_CONDITION.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.showStatus = 0;
    this.queryPostionLi();
    this.handleSearch();
  },
  watch: {
    search_code(val) {
      if (val) {
        this.tableData = this.tableData_ALL.filter((item) => {
          const t = String(item.PRODUCT_CODE);
          return t.includes(val);
        });
      } else {
        this.tableData = this.tableData_ALL;
      }
    },
    search_position(val) {
      if (val) {
        this.tableData = this.tableData_ALL.filter((item) => {
          const t = String(item.LOCATION_CODE);
          return t.includes(val);
        });
      } else {
        this.tableData = this.tableData_ALL;
      }
    },
  },
  computed: {
    // 上一次的搜索结果和条件
    WMS_TEMPORARYSTOCK_CONDITION() {
      return this.$store.state.WMS_TEMPORARYSTOCK_CONDITION;
    },
    POSITION_CONDITION() {
      return this.$store.state.POSITION_CONDITION;
    },
  },
  methods: {
    下载批次报告() {
      window.open(this.$util.getURLLocalHost(this.查看批次报告模态框表单.FILE_PATH), 'file');
    },
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      frontEndFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    queryPostionLi() {
      queryPosition({ STATUS: 1 }).then((result) => {
        this.positionListAll = Object.freeze(result);
        this.positionList = [...this.positionListAll];
        // 将库位信息存储到vuex中
        this.$store.dispatch('SET_POSITION_CONDITION', {
          POSITIONLIST: result,
        });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    positionFilter(query = '') {
      const arr = this.positionListAll.filter((item) => item.CODE.includes(query));
      if (arr.length > 50) {
        this.positionList = arr.slice(0, 50);
      } else {
        this.positionList = arr;
      }
    },
    // ---------------------------------------------导出
    exportOrder() {
      temporaryExport().then((res) => {
        window.location.href = res[0].FILE_PATH;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    submitExport() {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            FIRST_LEVEL_CATALOG: this.exportForm.firstLevel,
            SECOND_LEVEL_CATALOG: this.exportForm.secondLevel,
          };
          exportWarehouseFun(params).then((result) => {
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            this.exportFormVisible = false;
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    closeExport() {
      this.exportFormVisible = false;
      this.exportForm = {};
    },
    // ---------------------------显示隐藏库存为零
    showBlock() {
      if (this.showStatus !== 1) {
        this.showStatus = 1;
        this.getStorageList();
      } else {
        this.showStatus = 0;
        this.getStorageList();
      }
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.getStorageList();
    },
    // -----------------------------筛选功能
    handleSearch() {
      const params = {
        PRODUCT_NAME: this.searchForm.name,
        PAGESIZE: 9999,
        PAGEINDEX: this.currentPage - 1,
        SHOW: this.showStatus,
      };
      this.loading = true;
      const obj = JSON.parse(localStorage.getItem('临时仓上架库位记录')) || {};
      const lastCode = obj[parseInt(sessionStorage.getItem('userId'))] || '';
      queryTemporary(params).then((result) => {
        this.tableData = result[0].OP_ROLE.map((item) => Object.assign(item, {
          CXCOUNT: item.CXCount,
          PRODUCT_CODE: item.PRODUCT_CODE.toString(),
          LOCATION_CODE: item.LOCATION_CODE || lastCode,
        }));

        this.tableData_ALL = this.tableData.slice(0);
        // 将搜索结果和条件存储到vuex中
        this.$store.dispatch('SET_WMS_TEMPORARYSTOCK_CONDITION', {
          CONDITION: this.searchForm,
          CURRENT_PAGE: this.currentPage,
        });
        this.loading = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.loading = false;
      });
    },
    // ------------------------------------------点击一级大类获取一级大类内容
    getStorageList() {
      const params = {
        PRODUCT_NAME: this.searchForm.name,
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        SHOW: this.showStatus,
      };
      if (this.TAB_CODE > 99) {
        if (this.TAB_CODE) {
          params.FIRST_CATALOG_CODE = this.TAB_CODE;
        }
      }
      queryTemporary(params).then((result) => {
        this.totalCount = result[0].TOTAL_COUNT;
        this.tableData = result[0].OP_ROLE.map((item, index) => Object.assign(item, { CXCOUNT: item.CXCount }));
        if (result[0].TOTAL_WORTH !== '') {
          this.total_price = result[0].TOTAL_WORTH;
        } else {
          this.total_price = 0;
        }
        // 将搜索结果和条件存储到vuex中
        this.$store.dispatch('SET_SAVE_STOCKLIST', {
          CONDITION: this.searchForm,
          CURRENT_PAGE: this.currentPage,
        });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    addToStock(row) {
      // 防抖：一次只允许一个上架请求（批量上架进行中同样拦截）
      if (this.putOnRowLoadingId !== 0 || this.putOnLoading) return;
      if (!row.LOCATION_CODE) {
        this.$message.show({ text: '请先选择库位', type: 'warning' });
        return;
      }
      const params = {
        TEMP_ID: row.TEMP_ID,
        LOCATION_CODE: row.LOCATION_CODE,
      };
      this.putOnRowLoadingId = row.TEMP_ID;
      putOnStock(params).then((res) => {
        this.putOnRowLoadingId = 0;
        this.$message.show({ text: '上架成功', type: 'success' });
        const obj = JSON.parse(localStorage.getItem('临时仓上架库位记录')) || {};
        obj[parseInt(sessionStorage.getItem('userId'))] = row.LOCATION_CODE;
        localStorage.setItem('临时仓上架库位记录', JSON.stringify(obj));
        this.handleSearch();
      }).catch((error) => {
        this.putOnRowLoadingId = 0;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleSelectionChange(e) {
      this.putOnArr = Object.assign([], e);
    },
    multyAdd() {
      if (this.putOnArr.length === 0) {
        this.$message.show({ text: '请先勾选要上架的产品', type: 'warning' });
        return;
      }
      // 防抖：单条上架进行中不允许再发起批量上架
      if (this.putOnRowLoadingId !== 0) return;
      const params = {
        TEMP_PRODUCT_ARRAY: [],
      };
      const temp_arr = this.putOnArr.map((item) => ({ TEMP_ID: item.TEMP_ID, LOCATION_CODE: item.LOCATION_CODE }));
      params.TEMP_PRODUCT_ARRAY = temp_arr;
      this.putOnLoading = true;
      putOnStock_multy(params).then((res) => {
        this.putOnLoading = false;
        this.$message.show({ text: '上架成功', type: 'success' });
        this.handleSearch();
      }).catch((error) => {
        this.putOnLoading = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    downloadBatch(BATCH_REPORT_ID) {
      const params = {
        BATCH_REPORT_ID,
      };
      downloadBatchReport(params).then((result) => {
        this.查看批次报告模态框表单 = { ...result[0] };
        this.查看批次报告模态框 = true;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleSuccess(response, file, fileList) {
      this.url = response.file_name;
    },
    handleRemove(file, fileList) {
      this.fileList = [];
    },
    //   下载模板
    downLoadResetTemp() {
      window.location.href = 'https://service.linkda.com.cn/file/templates/pw2Manual_In_tmpWarehouse.xls';
    },
    closeImport() {
      this.fileList = [];
      this.importVisible = false;
    },
    submitImport() {
      const params = {
        FILE_NAME: this.url,
      };
      temporaryImport(params).then((result) => {
        if (result[0].FILE_PATH !== '') {
          window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
          this.$message.show({ text: '导入失败，失败原因查看下载文件', type: 'warning' });
        } else {
          this.$message.show({ text: '导入成功', type: 'success' });
        }
        this.handleSearch();
        this.importVisible = false;
        document.body.style.cursor = 'default';
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.importVisible = false;
        document.body.style.cursor = 'default';
      });
    },
    positionReset(callback) {
      if (callback == true) {
        this.positionList = this.positionListAll;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/warehouseManage/temporaryStock.vue